import HistoryLogIcon from '@/assets/icons/HistoryLogIcon';
import { Box, Drawer, IconButton, Typography, Divider } from '@mui/material';
import { MdClose } from 'react-icons/md';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetAgencyOnboardingFormHistories } from '@/apis/agency/businessOnboarding/hooks';
import { HistoryLog } from '@/apis/agency/businessOnboarding/types';
import Spinner from '@/components/Common/Spinner';
import { formatDate, titleCase } from '@/utils/helperFunctions';

export default function HistoryLogsDrawer() {
  const { onboardingFormId } = useParams<{ onboardingFormId: string }>();
  const navigate = useNavigate();

  const { data, isLoading, error } = useGetAgencyOnboardingFormHistories(onboardingFormId || '');

  const logs: HistoryLog[] = data?.data || [];

  const handleClose = () => {
    navigate('..');
  };
  return (
    <Drawer anchor='right' open={true} onClose={handleClose} PaperProps={{ sx: { width: 420 } }}>
      {/* Header */}
      <Box p={2} display='flex' justifyContent='space-between' alignItems='center'>
        <Typography variant='h6'>History Logs</Typography>
        <IconButton onClick={handleClose}>
          <MdClose />
        </IconButton>
      </Box>

      <Divider />

      {/* Logs */}
      <Box p={3}>
        {isLoading ? (
          <Box display='flex' justifyContent='center' alignItems='center' minHeight={200}>
            <Spinner />
          </Box>
        ) : error ? (
          <Box display='flex' justifyContent='center' alignItems='center' minHeight={200}>
            <Typography color='error'>Error loading history logs. Please try again.</Typography>
          </Box>
        ) : logs.length === 0 ? (
          <Box display='flex' justifyContent='center' alignItems='center' minHeight={200}>
            <Typography color='text.secondary'>No history logs found.</Typography>
          </Box>
        ) : (
          logs.map((log, index) => (
            <Box key={index} display='flex' alignItems='flex-start' gap='12px' mb={3}>
              {getLogIcon(log.action_type)}
              <Box
                bgcolor='#F8F9FA'
                sx={{
                  border: '1px solid #e5e7eb',
                  borderRadius: 2,
                  p: '12px',
                  width: '100%'
                }}
              >
                <Box display='flex' justifyContent='space-between' alignItems='center' mb={0.5}>
                  <Typography fontWeight={500} fontSize={16}>
                    {mapActionTypeToDisplay(log.action_type)}
                  </Typography>

                  <Typography
                    sx={{
                      border: '1px solid #e5e7eb',
                      borderRadius: '16px',
                      px: '16px',
                      py: '4px',
                      fontSize: '14px',
                      fontWeight: 500,
                      bgcolor: '#FFFFFF',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {log.changed_by?.name || 'Customer'}
                  </Typography>
                </Box>

                <Typography fontSize={13} color='text.secondary'>
                  {formatDate(log.created_at, 'DD MMM YYYY ; HH:mm')}
                </Typography>
              </Box>
            </Box>
          ))
        )}
      </Box>
    </Drawer>
  );
}

const getLogIcon = (type: string) => {
  switch (type) {
    default:
      return <HistoryLogIcon />;
  }
};

const mapActionTypeToDisplay = (type: string) => {
  switch (type?.toLowerCase()) {
    case 'draft':
      return 'Draft';
    case 'collecting_agent_info':
      return 'Collecting Agent Info';
    default:
      return titleCase(type);
  }
};
